import { useCallback } from 'react';

import { FixedAttachment } from '90.quickConnect.Models/models/fields/fieldDesc/attachmentField/fixedAttachmentDesc';
import { openFixedAttachment } from '50.quickConnect.Fields/FieldsTypes/Attachments/helpers/openFixedAttachment';

const useData = ({ distantUri = '', fileName = '', type = '' }: FixedAttachment) => {
  const onOpenAttachment = useCallback(() => {
    openFixedAttachment(type, distantUri);
  }, [distantUri, type]);

  return { distantUri, fileName, onOpenAttachment, type };
};

export default useData;
